export const CHANGE_HISTORY_SLICE_NAME = '@@changeHistory';
